export default "__VITE_ASSET__Dl7luQCz__"